import { store } from "@/store";
import { makeRequest } from "@/util";
import { User } from "@/components/users/types";
import { UPDATE_CURRENT_USER } from "@/reducers/users";

export interface UpdateUserProfilePayload {
  first_name?: string;
  last_name?: string;
  title?: string;
  avatar?: string;
}

export async function updateUserProfile(
  payload: UpdateUserProfilePayload,
): Promise<User> {
  const { data } = await makeRequest<User>("update_user_profile", payload);
  store.dispatch({ type: UPDATE_CURRENT_USER, user: data });
  return data;
}
